import React, { Component } from 'react';
import styled from 'styled-components';
import { withRouter } from 'react-router-dom';

const HamburgerMenuContainer = styled.div`
  @media (min-width: 801px) {
    display: none;
  } 
`;

const MenuContainer = styled.div`
  position: absolute;
  background: #1D2C3C;
  padding: 20px;
  width: 200px;
  top: 0;
  transition: 0.4s;
  z-index:2
  right: ${(props) => props.open ? '0' : '-240px' };
`;

const MenuOverlay = styled.div`
  background: #1D2C3C;
  height: 1000px;
  padding: 20px;
`;

const ButtonContainer = styled.div`
  z-index: 2;
  margin-right: 15px;
  margin-top: 11px;
`;

const Button = styled.div`
    cursor: pointer;
`;

const Bar = styled.div`
  width: 35px;
  height: 5px;
  background-color: #FFF;
  margin: 6px 0;
  transition: 0.4s;
`;

const Bar1 = styled(Bar)`
 transform: ${(props) => props.open ? 'rotate(-45deg) translate(-9px, 6px)' : 'none' };
`;

const Bar2 = styled(Bar)`
  opacity: ${(props) => props.open ? '0' : '1' };
`;

const Bar3 = styled(Bar)`
  transform: ${(props) => props.open ? 'rotate(45deg) translate(-8px, -8px)' : 'none' };
`;

class BurgerMenu extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.location.pathname !== nextProps.location.pathname) {
      this.setState({isOpen: false});
    }
  }

  toggleMenu() {
    this.setState({isOpen: !this.state.isOpen})
  }

  render() {
    return (
      <HamburgerMenuContainer>
        <ButtonContainer>
          <Button onClick={() => this.toggleMenu()}>
            <Bar1 open={this.state.isOpen}/>
            <Bar2 open={this.state.isOpen}/>
            <Bar3 open={this.state.isOpen}/>
          </Button>
        </ButtonContainer>
        <MenuContainer open={this.state.isOpen}>
          <Button onClick={() => this.toggleMenu()}>
            <Bar1 open={this.state.isOpen}/>
            <Bar2 open={this.state.isOpen}/>
            <Bar3 open={this.state.isOpen}/>
          </Button>

          <MenuOverlay onClick={() => this.toggleMenu()}>
            {this.props.children}
          </MenuOverlay>
        </MenuContainer>
      </HamburgerMenuContainer>
    );
  }
}

export default withRouter(BurgerMenu);



// WEBPACK FOOTER //
// ./src/Containers/BurgerMenu.js